/**
 * Tiny inline sparkline used by KPI stat cards. Pure SVG, no deps.
 * Returns null for <2 data points (collapsed cards) to avoid a 1-pixel artifact.
 */
export const Sparkline = ({ data = [], color = '#22C55E', width = 60, height = 24 }) => {
  if (!data || data.length < 2) return null;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const points = data
    .map((v, i) => `${(i / (data.length - 1)) * width},${height - ((v - min) / range) * height}`)
    .join(' ');
  return (
    <svg width={width} height={height} className="opacity-60">
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Sparkline;
